import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductPricingPlanClass.List.IRequest;
type Response = Api.Core.ProductPricingPlanClass.List.IResponse;
type Headers = Api.Core.ProductPricingPlanClass.List.IHeaders;
const url = '/api/ProductManagement/ProductPricingPlanClass';
export default async function productPricingPlanClassListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
